
import _request from "../common/_request";

let lib_expo = {
    //城市列表
    list: function ( callback) {

        _request._get('/expo/list', null,function (response) {
            if (response.code !== _request.success) {
                return;
            }
            //回调数据
            callback(response.data)
        })
    },

    //城市列表
    minilist: function ( callback) {

        _request._get('/expo/minilist', null,function (response) {
            if (response.code !== _request.success) {
                return;
            }
            //回调数据
            callback(response.data)
        })
    },


};
export default lib_expo
